<template>
  <div class="d-flex">
    <v-btn
      id="menu-activator"
      elevation="0"
      class="select-language-menu"
      outlined
    >
      <div class="d-flex justify-start">
        <span v-if="selectCurrentLanguage.flag" :class="selectCurrentLanguage.flag" class="me-2"></span>
        <v-avatar size="20" class="me-2">
          <img :src="`/images/flag/${selectCurrentLanguage.flag}.svg`"
                style="object-fit: cover; width: 100%; height: 100%" />
        </v-avatar>
        {{ selectCurrentLanguage.name || 'Select language' }}
      </div>
      <div>
        <v-icon>mdi-menu-down</v-icon>
      </div>
    </v-btn>

    <v-menu activator="#menu-activator" location="bottom" offset-y>
      <v-list>
        <v-list-item v-for="(country, index) in countrys" :key="index" @click="changeLanguage(country)">
          <v-list-item-title class="d-flex">
            <div>
              <v-avatar size="20" class="me-2"><img :src="`/images/flag/${country.flag}.svg`"
                  style="object-fit: cover; width: 100%; height: 100%" /></v-avatar>
              {{ country.name }}
            </div>
            <v-icon v-if="country.name === selectCurrentLanguage.name" color="success" size="18">
              mdi-check
            </v-icon>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  data: () => ({
    selectCurrentLanguage: 'th-TH',
    countrys: {
      'th-TH': {
        code: 'th-TH',
        flag: 'TH',
        name: 'ไทย'
      },
      'lo-LA': {
        code: 'lo-LA',
        flag: 'LA',
        name: 'ລາວ'
      },
      // 'en-US': {
      //   code: 'en-US',
      //   flag: 'US',
      //   name: 'English'
      // }
    }
  }),
  mounted() {
    const savedLanguage = localStorage.getItem('selectedLanguage')
    if (!savedLanguage) {
      this.changeLanguage(this.countrys['th-TH'])
      return
    }
    const foundLanguage = this.countrys[savedLanguage]
    foundLanguage ? this.changeLanguage(foundLanguage) : this.changeLanguage(this.countrys['th-TH'])
  },
  methods: {
    changeLanguage(newCountry) {
      this.selectCurrentLanguage = newCountry
      this.$i18n.locale = newCountry.code
      localStorage.setItem('selectedLanguage', newCountry.code)
    }
  }
}
</script>

<style lang="scss" scoped>

.select-language-menu {
  font-size: 14px;
  border-radius: 999px;
  border: 1px solid #a1a1a1;
  cursor: pointer;
  padding: 0px 3px !important;
  justify-content: space-between;
  min-width: 130px !important;
}
</style>